import React, { useState, useEffect } from 'react'
import DatePicker from 'react-datepicker'
import { Autocomplete } from '../components/_Autocomplete';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import moment from 'moment';
import { set } from 'date-fns';
import { AutoComplete, Select } from 'antd';
import AutoCompleteCities from '../components/AutoCompleteCities';
import { ManulApiModel } from '../models/ManulApiModel';
import { SimulatorModel } from '../models/SimulatorModel';
import '../assets/css/_new-lead-popup.css'
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { calculateAge } from "../utils/dateUtils";

interface IVehicleOwnerTabsProps {
    productionData: any,
    customerId?: string;
    setProductionDataData: (name: string, e: any) => void,
    setStateData: (name: string, e: any) => void,
    loadStreets: (e: any) => void,
    loadCities: (e: any) => void,
    citiesForSearch: any,
    geder: any,
    identityTypes: any,
    maritalStatus: any,
    birthDateRef: React.RefObject<DatePicker>,
    identifierDateRef: React.RefObject<DatePicker>,
    renderValidationError: (name: string) => React.ReactNode,
    citiesListData: any[],
    streetsListData: any[],
    setStreetsState: (value: any) => void,
    setAlertMessege: (e: any, navigate: string) => void,
    onBlurOwnerCustomerData: (name: string, value: any) => void;
    loadData: (value: string) => void;
}

const PersonalDetailsDriver: React.FC<IVehicleOwnerTabsProps> = ({
    productionData,
    customerId,
    setProductionDataData,
    setStateData,
    loadStreets,
    loadCities,
    citiesForSearch,
    geder,
    identityTypes,
    maritalStatus,
    birthDateRef,
    identifierDateRef,
    renderValidationError,
    citiesListData,
    streetsListData,
    setStreetsState,
    setAlertMessege,
    onBlurOwnerCustomerData,
    loadData
}) => {

    // useEffect(() => {

    //     const fetchStreetsData = async () => {
    //         if (productionData.ownerAddress != null && productionData.ownerAddress.length > 0 && productionData.ownerAddress[0].city) {
    //             let val = productionData.ownerAddress[0].city.replace(/\s/g, '')
    //             const streetAutocomplete = await new SimulatorModel().getStreetsAutocomplete(val);
    //             console.log('streetAutocomplete', streetAutocomplete)
    //             // setStreetsList([...streetAutocomplete.map((street: any) => street.value)])
    //             setStreetsState([...streetAutocomplete.map((street: any) => street.value)])
    //         }
    //     }
    //     fetchStreetsData()
    // }, [])
    const GUID_EMPTY = '00000000-0000-0000-0000-000000000000'




    // const calculateAge = (dateOfBirth: Date) => {
        // const today = new Date(productionData.startDate);// new Date(); 
        // const birthDate = new Date(dateOfBirth);
        // let age = today.getFullYear() - birthDate.getFullYear();
        // const monthDiff = today.getMonth() - birthDate.getMonth();

        //Check if the birthday has not occurred yet this year
        // if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            // age--;
        // }
        // return age;
    // }

    const setAdressData = async (name: string, value: any) => {

        const addresses = productionData.ownerAddress;
        if (name == "postalCode") {
            setAlertMessege('לשינוי מיקוד הלקוח', 'simulator');
            return;
        }
        // if (name == "city") {
        //     setAlertMessege('לשינוי עיר הלקוח', 'simulator');
        //     return;
        // }

        addresses[name] = name === 'houseNumber' ? Number(value) : value;

        console.log('addresses', addresses)
        setProductionDataData("customerAddresses", addresses);
    }

    const setCustomerContactDetails = (name: string, value: any) => {
        const contactDetails = productionData.ownerContactDetails;
        contactDetails[name] = value;
        setProductionDataData("customerContactDetails", contactDetails);
    }


    const datePresentation = (date: Date) => {
        if (date != null) {
            return moment(date).format('dd/MM/yyyy');
        }
        return "";
    }

    const setCustomerDetails = (name: string, value: any) => {

        // if (name == "maritalStatus") {
        //     setAlertMessege('לשינוי תאריך לידה של הלקוח', 'simulator');
        //     return;
        // }
        if (name == "gender") {
            setAlertMessege('לשינוי מין הלקוח', 'simulator');
            return;
        }

        setProductionDataData(name, value);
    }


    const calcAge = (e: any, name: string) => {
        //
        console.log('e :>> ', e);
        console.log('name :>> ', name);

        if (productionData != null) {
            var birthDate = e;
            if (birthDate != null) {
                var diff_ms = Date.now() - e.getTime();

                var age_dt = new Date(diff_ms);
                var age = Math.abs(age_dt.getUTCFullYear() - 1970);

                console.log('e :>> ', e);
                console.log('age :>> ', age);
                switch (name) {
                    case "ownerDateOfBirth": {
                        setProductionDataData("ownerDateOfBirth", e);
                        break;
                    }
                    case "ownerIdentityIssueDate": {
                        setProductionDataData("ownerIdentityIssueDate", e);
                        break;
                    }
                }
            }
        }
    }

    const errorMessages = (fieldName: string) => {
        return renderValidationError(fieldName) ? { border: '1px solid red' } : {}
    }

    const emptyDate = (date: string) => {
        if (!date)
            return true;
        const _date = new Date(date);
        if (_date.getFullYear() === 1 && _date.getMonth() === 0 && _date.getDate() === 1)
            return true;
        return false;
    }

    const isNullOrEmptyGuid = (guid?: string | null): boolean => {
        return (
            !guid ||
            guid.trim() === "" ||
            guid === "00000000-0000-0000-0000-000000000000"
        );
    };

    const isCustomerEnebled = () => {
        if (!isNullOrEmptyGuid(customerId))
            return true;
        return false;
    }

    if (!identityTypes || !maritalStatus) {
        return <div>Loading...</div>
    }

    return (


        <>

            {productionData != null && (productionData.ownerIdentityType == 0 || productionData.ownerIdentityType == 1 || productionData.ownerIdentityType == 2) &&
                <div className="parameter-row">
                    <div className="parameter-item" >
                        <div className="field">
                            <div className="title">
                                שם פרטי
                            </div>
                            <div className="value" style={errorMessages("ownerFirstName")}>
                                <input disabled={isCustomerEnebled()} type="text" onChange={(e: any) => setProductionDataData("ownerFirstName", e.target.value)} value={productionData != null ? productionData.ownerFirstName : ""} placeholder='שדה חובה*' />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>
                                    {renderValidationError("ownerFirstName")}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם משפחה
                            </div>
                            <div className="value" style={errorMessages("ownerLastName")}>
                                <input disabled={isCustomerEnebled()} type="text" onChange={(e: any) => setProductionDataData("ownerLastName", e.target.value)} value={productionData != null ? productionData.ownerLastName : ""} placeholder='שדה חובה*' />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("ownerLastName")}</div>

                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך לידה
                            </div>
                            <div className="value" style={errorMessages("ownerDateOfBirth")}>


                                <CompDatePicker disabled={isCustomerEnebled()} value={productionData != null && productionData.ownerDateOfBirth != null && !emptyDate(productionData.ownerDateOfBirth) ? new Date(productionData.ownerDateOfBirth) : undefined}
                                    onChange={(e: any) => calcAge(e, "ownerDateOfBirth")}
                                    onBlur={(value: any) => onBlurOwnerCustomerData("ownerDateOfBirth", value)}
                                    placeholder='שדה חובה*'
                                />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("ownerDateOfBirth")}

                                </div>
                                <div className="icon small-icon calendar pointer"></div>



                            </div>

                        </div>
                        <div className="field">
                            <div className="title">
                                גיל
                            </div>
                            <div className="value grey-text-age">
                                {productionData != null && productionData.ownerDateOfBirth != null && !emptyDate(productionData.ownerDateOfBirth) ? calculateAge(productionData.ownerDateOfBirth as Date,productionData.startDate) : null}
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מצב משפחתי
                            </div>
                            <div className="value">

                                {maritalStatus ? (<IDNameDescriptionItemSelect Disabled={isCustomerEnebled()} OnChange={setCustomerDetails} Id={"ownerMaritalStatus"} Options={maritalStatus} Value={productionData != null ? productionData.ownerMaritalStatus : null} />
                                ) : ""}

                            </div>
                        </div>
                    </div>
                </div>
            }
            <div className="parameter-row">
                {productionData != null && (productionData.ownerIdentityType == 3 || productionData.ownerIdentityType == 4) &&
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם חברה
                            </div>
                            <div className="value" style={errorMessages("firstName")}>
                                <input disabled={isCustomerEnebled()} type="text" onChange={(e: any) => setProductionDataData("firstName", e.target.value)} value={productionData != null ? productionData.ownerFirstName + ' ' + productionData.ownerLastName : ""} placeholder='שדה חובה*' />
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>
                                    {renderValidationError("firstName")}
                                </div>

                            </div>
                        </div>
                    </div>
                }
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            ת.ז., ח.פ. ,מס' עמותה
                        </div>
                        <div className="value">


                            {identityTypes ? (<IDNameDescriptionItemSelect Disabled={isCustomerEnebled()} OnChange={setProductionDataData} Id={"ownerIdentityType"} Options={identityTypes} Value={productionData != null ? productionData.ownerIdentityType : null} />
                            ) : ""}
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            מספר
                        </div>
                        <div className="value" style={errorMessages("ownerIdentifier")}>
                            <input type="text" disabled={isCustomerEnebled()}
                                onChange={(e: any) => setProductionDataData("ownerIdentifier", e.target.value)}
                                onBlur={(e: any) => onBlurOwnerCustomerData("ownerIdentifier", e.target.value)}
                                value={productionData != null ? productionData.ownerIdentifier : ""} placeholder='שדה חובה*' />
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'end',
                                paddingTop: '5px',
                                color: 'red'
                            }}>{renderValidationError("ownerIdentifier")}</div>
                        </div>
                    </div>
                </div>
                {productionData != null && (productionData.ownerIdentityType == 0 || productionData.ownerIdentityType == 1 || productionData.ownerIdentityType == 2) &&
                    <>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך הנפקת ת.ז
                                </div>
                                <div className="value" style={errorMessages("ownerIdentityIssueDate")}>
                                    {/* <DatePicker
                                        ref={identifierDateRef}
                                        selected={productionData != null && productionData.ownerIdentityIssueDate != null ? new Date(productionData.ownerIdentityIssueDate) : null}
                                        onSelect={(e: any) => calcAge(e, "identityIssueDate")}
                                        onChange={(e: any) => calcAge(e, "identityIssueDate")}
                                        dateFormat='dd/MM/yyyy'
                                    /> */}
                                    <CompDatePicker disabled={isCustomerEnebled()} value={productionData != null && productionData.ownerIdentityIssueDate != null && !emptyDate(productionData.ownerIdentityIssueDate) ? new Date(productionData.ownerIdentityIssueDate) : null}
                                        onChange={(e: any) => calcAge(e, "ownerIdentityIssueDate")} />


                                    <div className="icon small-icon calendar pointer"></div>
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("identityIssueDate")}</div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מגדר
                                </div>
                                <div className="value">
                                    {geder ? (<IDNameDescriptionItemSelect Disabled={isCustomerEnebled()} OnChange={setProductionDataData} Id={"ownerGender"} Options={geder} Value={productionData != null ? productionData.ownerGender : null} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>


            {productionData.ownerAddress ? (
                <>
                    <div className="parameter-row">
                        <div className="parameter-item" style={{ maxWidth: '190px', minWidth: '190px' }}>
                            <div className="field">
                                <div className="title">
                                    ישוב
                                </div>

                                <div style={errorMessages("city")}>
                                    <AutoCompleteCities disabled={isCustomerEnebled()}
                                        dataValue={productionData != null && productionData.ownerAddress != null ? productionData.ownerAddress.city : ""}
                                        citiesListData={citiesListData}
                                        setAdressData={setAdressData}
                                        field={"city"}
                                    />
                                </div>
                                {/* <Autocomplete Value={productionData != null && productionData.ownerAddress != null ? productionData.ownerAddress[0].city : ""} Id="city"
                                        ClassName=''
                                        OnSelect={loadStreets}
                                        DataList={citiesForSearch}
                                        OnChange={loadCities}
                                    /> */}
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("city")}</div>
                            </div>
                        </div>
                        <div className="parameter-item" style={{ maxWidth: '190px', minWidth: '190px' }}>
                            <div className="field">
                                <div className="title">
                                    רחוב
                                </div>
                                {/* <input type="text"
                                        onChange={(e: any) => setAdressData("street", e.target.value)}
                                        value={productionData != null && productionData.ownerAddress != null ? productionData.ownerAddress[0].street : ""} /> */}
                                <div style={errorMessages("street")}>
                                    <AutoCompleteCities disabled={isCustomerEnebled()}
                                        dataValue={productionData != null && productionData.ownerAddress != null && productionData.ownerAddress.street != null ? productionData.ownerAddress.street : ""}
                                        citiesListData={streetsListData}
                                        setAdressData={setAdressData}
                                        field={"street"}
                                        onBlur={(value: any) => onBlurOwnerCustomerData("street", value)}
                                    />
                                </div>
                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'end',
                                    paddingTop: '5px',
                                    color: 'red'
                                }}>{renderValidationError("street")}</div>
                            </div>
                        </div>
                        <div className="parameter-item" style={{ maxWidth: '190px', minWidth: '190px' }}>
                            <div className="field">
                                <div className="title">
                                    מספר בית
                                </div>
                                <div className="value" style={errorMessages("houseNumber")}>
                                    <input type="number" disabled={isCustomerEnebled()}
                                        onChange={(e: any) => setAdressData("houseNumber", e.target.value)}
                                        onBlur={(e: any) => onBlurOwnerCustomerData("houseNumber", e.target.value)}
                                        value={productionData != null && productionData.ownerAddress != null ? productionData.ownerAddress.houseNumber : ""} placeholder='שדה חובה*' />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("houseNumber")}</div>
                                </div>
                            </div>
                        </div>

                        <div className="parameter-item" style={{ maxWidth: '190px', minWidth: '190px' }}>
                            <div className="field">
                                <div className="title">
                                    כניסה
                                </div>
                                <div className="value" style={errorMessages("entry")}>
                                    <input type="text" disabled={isCustomerEnebled()}
                                        onChange={(e: any) => setAdressData("entry", e.target.value)}
                                        value={productionData != null && productionData.ownerAddress != null ? productionData.ownerAddress.entry : ""} />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("entry")}</div>
                                </div>
                            </div>
                        </div>

                        <div className="parameter-item" style={{ maxWidth: '190px', minWidth: '190px' }}>
                            <div className="field">
                                <div className="title">
                                    מספר דירה
                                </div>
                                <div className="value" style={errorMessages("apartmentNumber")}>
                                    <input type="number" disabled={isCustomerEnebled()}
                                        onChange={(e: any) => setAdressData("apartmentNumber", e.target.value)}
                                        value={productionData != null && productionData.ownerAddress != null ? productionData.ownerAddress.apartmentNumber : ""} />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("apartmentNumber")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

            ) : ""}


            <div className="parameter-row">
                {productionData.ownerAddress &&
                    <>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    ת.ד.
                                </div>
                                <div className="value" style={errorMessages("mailbox")}>
                                    <input type="text" disabled={isCustomerEnebled()}
                                        onChange={(e: any) => setAdressData("mailbox", e.target.value)}
                                        onBlur={(e: any) => onBlurOwnerCustomerData("mailbox", e.target.value)}
                                        value={productionData != null && productionData.ownerAddress != null ? productionData.ownerAddress.mailbox : ""} />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("mailbox")}</div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מיקוד
                                </div>
                                <div className="value" style={errorMessages("postalCode")}>
                                    <input type="text" disabled={isCustomerEnebled()}
                                        onChange={(e: any) => setAdressData("postalCode", e.target.value)}
                                        value={productionData != null && productionData.ownerAddress != null && productionData.ownerAddress.postalCode != null ? productionData.ownerAddress.postalCode : ""} placeholder='שדה חובה*' />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("postalCode")}</div>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {productionData.ownerContactDetails &&
                    <>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    טלפון
                                </div>
                                <div className="value" style={errorMessages("number")}>
                                    <input type="text" disabled={isCustomerEnebled()}
                                        onChange={(e: any) => setCustomerContactDetails("number", e.target.value)}
                                        value={productionData != null && productionData.ownerContactDetails != null && productionData.ownerContactDetails.number ? productionData.ownerContactDetails.number : ""} placeholder='שדה חובה*' />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("number")}</div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    אימייל
                                </div>
                                <div className="value" style={errorMessages("emailAddress")}>
                                    <input type="text" disabled={isCustomerEnebled()}
                                        onChange={(e: any) => setCustomerContactDetails("emailAddress", e.target.value)}
                                        value={productionData != null && productionData.ownerContactDetails != null ? productionData.ownerContactDetails.emailAddress : ""} />
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'end',
                                        paddingTop: '5px',
                                        color: 'red'
                                    }}>{renderValidationError("emailAddress")}</div>
                                </div>
                            </div>
                        </div>
                    </>
                }

            </div>
            <div className='parameter-row'>
                <div className="parameter-item" style={{ minWidth: '100%' }}>
                    <div className="field">
                        <div className="title">
                            העתק נתונים מהצעה קיימת
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="העתק נתונים"
                                onChange={loadData}
                                options={
                                    productionData.moreOffers.map((item: any) => ({
                                        value: item.offerId,
                                        label: item.offerIdentity
                                    }))
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default PersonalDetailsDriver